import classes from "./AddMedia.module.css";
import AddIcon from '@mui/icons-material/Add';

const AddMedia = (props) =>{

    const click_action_handler = () =>{
        props.click()
    }
    return <div className={classes.main} onClick={click_action_handler}>
        {/* <AddIcon/> */}
    </div>
}
export default AddMedia